export default __webpack_public_path__ + "static/media/0070ROUGE.9975673c.pdf";